export const TV_PIP_SETTINGS = 'tv:pip-settings';
export const TV_PIP_SETTINGS_APPLY = 'tv:pip-settings:apply';
export const TV_PIP_SIZES = ['extraSmall', 'small', 'medium', 'large', 'extraLarge'] as const;
export interface TvPipSettings { pipSize: typeof TV_PIP_SIZES[number]; pipVisible: boolean }
export function isTvPipSettings(value: unknown): value is TvPipSettings {
  if (!value || typeof value !== 'object') return false;
  const settings = value as TvPipSettings;
  return TV_PIP_SIZES.includes(settings.pipSize) && typeof settings.pipVisible === 'boolean';
}
